// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3k3Va","list":"styles_list__2r6Ht"};